import { createSelector } from 'reselect'

export const getPhotos = createSelector(
  state => state && state.ads && state.ads.shared && Array.isArray(state.ads.shared.photos) ? state.ads.shared.photos : [],
  photos => photos
)
